// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lWno","content":"styles_content__3fD39","row":"styles_row__3oq-g","footer":"styles_footer__1HEgu","phraseLength":"styles_phraseLength__1B-Yp"};